export const Constant = {
  ActiveStatus: [
    { name: 'Active', value: true },
    { name: 'InActive', value: false },
  ],

  IsPublicStatus: [
    { name: 'Public', value: true },
    { name: 'Private', value: false },
  ],

  StudyAccessType: [
    { name: 'Public', value: 'public' },
    { name: 'Private', value: 'private' },
  ],

  UserRoles: ['superadmin', 'admin'],

  LocalStorageKey: {
    studyId: 'studyId',
  },
};
